export default "__VITE_ASSET__kQ01w6hj__"